import { TBlkCxpRole } from '../app/types/settingsDataModule';
import { IPermissionConfigType } from './rolesDataModule';

export const permissionsConfig: IPermissionConfigType = {
  USER_MANAGEMENT: {
    'view-users': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'create-users': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'edit-users': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'delete-users': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'assign-roles': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'manage-user-groups': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'reset-user-passwords': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'enable-disable-users': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
  },
  CONTACT_MANAGEMENT: {
    'view-contacts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'create-contacts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'edit-contacts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'delete-contacts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
    ],
    'import-contacts-csv-excel': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
    ],
    'export-contacts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
    ],
    'manage-contact-groups': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'merge-duplicate-contacts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
    ],
    'view-contact-history': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
  },
  MESSAGE_CONTENT_MANAGEMENT: {
    'compose-sms': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'send-test-msg': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'send-bulk-sms': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'view-sent-messages': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'delete-sent-messages': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'create-message-templates': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'edit-message-templates': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'delete-message-templates': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'approve-message-templates': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'schedule-messages': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'cancel-scheduled-messages': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
  },
  CAMPAIGN_MANAGEMENT: {
    'view-campaigns': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'create-campaigns': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'edit-campaigns': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'delete-campaigns': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'launch-campaigns': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'pause-resume-campaigns': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'view-campaign-analytics': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'export-campaign-reports': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
  },
  ACCOUNT_MANAGEMENT: {
    'view-account-settings': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'edit-account-settings': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'manage-sender-ids': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'request-new-sender-ids': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'view-subscription-plan': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'upgrade-downgrade-plan': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'manage-sub-accounts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'view-account-activity-log': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
  },
  FINANCE_AND_BILLING: {
    'view-balance-credits': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'purchase-credits': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'view-invoices': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'download-invoices': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'view-transaction-history': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'manage-payment-methods': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'view-pricing-plans': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'generate-financial-reports': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'view-cost-analytics': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'set-budget-alerts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
  },
  API_AND_INTEGRATIONS: {
    'view-api-keys': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'generate-api-keys': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'revoke-api-keys': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'view-api-documentation': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'configure-webhooks': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'manage-third-party-integrations': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'view-api-usage-statistics': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'set-rate-limits': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'test-api-endpoints': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
  },
  REPORTS_AND_ANALYTICS: {
    'view-delivery-reports': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'view-analytics-dashboard': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'generate-custom-reports': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'export-reports-pdf-excel': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'schedule-automated-reports': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
    ],
    'view-real-time-statistics': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'access-historical-data': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
  },
  SYSTEM_ADMINISTRATION: {
    'view-system-settings': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'modify-system-settings': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'view-audit-logs': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'export-audit-logs': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'manage-security-settings': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'configure-two-factor-auth': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'ip-whitelist-management': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'backup-and-restore': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'view-system-health': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'manage-notifications-settings': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
      'ROLE_BLKKCXP_FINANCE_DATA_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
  },
  COMPLIANCE_AND_SECURITY: {
    'view-opt-out-lists': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'manage-opt-out-lists': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
    ],
    'view-dnd-registry': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
      'ROLE_BLKKCXP_CONTENT_MANAGER',
    ],
    'configure-compliance-rules': ['SUPER_ADMIN', 'ROLE_BLKKCXP_ADMINISTRATOR'],
    'view-security-alerts': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_INTEGRATIONS_MANAGER',
    ],
    'manage-blacklists': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
    ],
    'gdpr-data-requests': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
    ],
    'view-consent-records': [
      'SUPER_ADMIN',
      'ROLE_BLKKCXP_ADMINISTRATOR',
      'ROLE_BLKKCXP_ACCOUNT_MANAGER',
      'ROLE_BLKKCXP_CONTACTS_MANAGER',
    ],
  },
};
